import { useRouter } from 'next/router';
import Link from 'next/link';
// Types
import { GetMediaPost_getMediaPost } from 'api/mediaPost/types/GetMediaPost';
// Constants
import { MEDIA } from 'constants/routes';
// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './MediaFeedNavigation.module.scss';

type MediaFeedNavigationProps = {
  mediaFeed: GetMediaPost_getMediaPost;
};

const MediaFeedNavigation = ({ mediaFeed }: MediaFeedNavigationProps) => {
  const { query } = useRouter();

  const athleteSlug = query.athleteSlug as string;

  const mediaFeedUrl = () => {
    return (
      <div className={styles.link}>
        <Link href={`/${athleteSlug}${MEDIA}`}>Media Feed</Link>
      </div>
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.text}>
        {mediaFeed.store.storeDetails?.storeName}
      </div>

      <MillionsIcon name="chevronRight" className={styles.icon} />
      {mediaFeedUrl()}
    </div>
  );
};

export default MediaFeedNavigation;
